<template>
  <div class="loader" :class="{ 'loader-fullscreen': fullscreen, 'p-5': !fullscreen }">
    <div>
      <div class="loader-icon">
        <base-icon class="text-primary" icon="spinner" spin />
      </div>
      <div v-if="hasText()" class="loader-text">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoader',

  props: {
    fullscreen: Boolean
  },

  methods: {
    hasText () {
      return this.$_.has(this.$slots, 'default')
    }
  }
}
</script>
